var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _line, _line2, _rect3, _rect4, _line3, _line4, _circle, _circle2, _path9, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEscalationPolicy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 253,
    height: 175,
    viewBox: "0 0 253 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.732 36.4045C189.629 36.4045 192.788 33.2887 192.788 29.4452C192.788 25.6017 189.629 22.4859 185.732 22.4859C181.835 22.4859 178.676 25.6017 178.676 29.4452C178.676 33.2887 181.835 36.4045 185.732 36.4045Z",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.591 13.3756C95.496 13.3756 97.851 11.053 97.851 8.18782C97.851 5.32267 95.496 3 92.591 3C89.6859 3 87.331 5.32267 87.331 8.18782C87.331 11.053 89.6859 13.3756 92.591 13.3756Z",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.063 44.5026L43.7113 55.0047",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.063 55.0047L43.7113 44.5026",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M220.269 61.7711L234.379 66.7311",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M224.747 71.271L229.901 57.2312",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7961 123.481L3 141.576C3 141.955 3.38488 142.335 3.76976 142.082L20.5761 134.49C20.961 134.363 20.961 133.857 20.7044 133.604L5.69415 123.102C5.30927 122.849 4.7961 123.102 4.7961 123.481Z",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M241.806 128.967L224.919 136.458C224.567 136.614 224.487 137.065 224.758 137.36L239.615 148.072C240.003 148.315 240.473 148.107 240.436 147.708L242.466 129.505C242.598 129.169 242.158 128.811 241.806 128.967Z",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 72.4471,
    y: 68.4588,
    width: 136.553,
    height: 105.635,
    rx: 8,
    fill: "#D7D5FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 56.5,
    width: 131.553,
    height: 100.635,
    rx: 5.5,
    fill: "white",
    stroke: "#4147EB",
    strokeWidth: 5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 118.5,
    y1: 91.8647,
    x2: 134.112,
    y2: 91.8647,
    stroke: "#DEDBFE",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 118.5,
    y1: 125.359,
    x2: 134.112,
    y2: 125.359,
    stroke: "#DEDBFE",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 101,
    width: 53,
    height: 10,
    rx: 5,
    fill: "#ADABFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 135,
    width: 53,
    height: 9,
    rx: 4.5,
    fill: "#ADABFF"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 61.5765,
    y1: 73.8294,
    x2: 192.976,
    y2: 73.8294,
    stroke: "#4147EB",
    strokeWidth: 5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 71.8059,
    y1: 64.3824,
    x2: 86.5588,
    y2: 64.3824,
    stroke: "#4147EB",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 128,
    r: 43.5,
    fill: "white",
    stroke: "#4147EB",
    strokeWidth: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 128,
    r: 28.5,
    stroke: "#4147EB",
    strokeWidth: 5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.6053 108.632C75.9339 108.632 74.5789 109.986 74.5789 111.658V130.407C74.3832 131.261 74.558 132.193 75.1367 132.939L82.2103 142.063C83.2344 143.384 85.1353 143.625 86.4563 142.601C87.7772 141.577 88.0179 139.676 86.9938 138.355L80.6316 130.148V111.658C80.6316 109.987 79.2767 108.632 77.6053 108.632Z",
    fill: "#ADABFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 129.5,
    r: 4,
    fill: "#ADABFF",
    stroke: "#ADABFF",
    strokeWidth: 5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscalationPolicy);
export default __webpack_public_path__ + "static/media/EscalationPolicy.f9fa80cac16394f998417cbfa7ea8846.svg";
export { ForwardRef as ReactComponent };